 const schoolData = [
    {
        school: "All",
        region: []
    },
    {
        school: "UNIPORT",
        region: ["Alakahia","Aluu","Back of Chem","Choba","Choba Extension","Rumousi"]
    },
    
    {
        school: "ABIA-POLY",
        region: ["Immaculate", "Railway", "Star-paper", "Ususu", ]
    },
    {
        school: "AGBOR-UNI",
        region: ["Agbo-obi", "Alihame", "Board Road Axis" ]
    },
    {
        school: "AKSU",
        region: ["Apkaden","Eket Road Axis","Etim-town","Ikot Obio Ndoho","Ikot Oyoro","Ikot Isighe","Ndoho","Uyo Road Axis"]
    },
    {
        school: "COOU",
        region: ["Igbariam Campus","Uli Campus"]
    },
    {
        school: "DELSU",
        region: ["Campus 1","Campus 2", "Campus 3","Express","Ekrejeta","Igbo Quarters","Lucas Road Axis","Lucas Road Axis","Old Road Axis","River Road Axis","Station Road Axis"]
    },
    {
        school: "FUNAAB",
        region: ["Camp","Gate","Isolu","Oluwo"]
    },
    {
        school: "FUTA",
        region: ["North Gate","South Gate","West Gate"]
    },
    {
        school: "FUTO",
        region: ["Eziobodo","Ihiagwe","Obinnze","Umuchima"]
    },
    {
        school: "IMSU",
        region: ["Aladinma Alliance","Front Gate","Works Layout","Oji","Okwu-uratta", "Bishops Court Alliance", "Ikenaebu"]
    },
     {
        school: "NDU",
        region: ["Ebicrest","Efeke","Ending Pele","NDDC Road","Ogbobiri","Ogbopina"]
    },
    {
        school: "OOU",
        region: ["Ago Iwoye","Oru","Awa"]
    },
    {
        school: "RSU",
        region: ["Ada George","Azikiwe","Back Gate","Eagle Island","Ikoku","Main Gate","Mgboushimini"]
    },
    {
        school: "UNIABUJA",
        region: ["Iddo","Sarki","Giri","Kutunku","Phase 1, 2, 3"]
    },
    {
        school: "UNIBEN",
        region: ["BDPA","Ekosodin","Oluku","Osasogie","Wasota"]
    },
    {
        school: "UNICAL",
        region: ["Mount Zion","Yello Duke","Goldie","Satellite Town","Etta-agbor","Mary Slessor"]
    },
    {
        school: "UNIJOS",
        region: ["Farin-gada","Rusau","Sukuwa"]
    },
    {
        school: "UNILORIN",
        region: ["Chapel Bustop","MFM Bustop","Oke-odo|Oko-oba","Staff Quarters","Stalla Marris","Tanke Bubu","Tanke Ille","Tipper Garage"]
    },
    {
        school: "UNIUYO",
        region: ["Ekpany","Ikpa Road","Itu Road","Udoette","Urua Ikpa"]
    },
    {
        school: "UNIZIK",
        region: ["Amansea","Aroma","Commissioners Quarter Axis","Ifite","Reginal","School Gate Axis","Tempsite"]
    },
];

export default schoolData;
   	   
